export enum EStatusNotaFiscalServico
{
    Pendente = 1,
    Autorizada = 2,
    Cancelada = 3,
    EmProcessamento = 4
}
